import { Component } from '@angular/core';
import { AuthService } from '@core/services/auth/auth.service';
import { ChangePasswordFormComponent } from "../../../modules/settings/components/change-password-form/change-password-form.component";
import { StepperModule } from 'primeng/stepper';
import { InputOtpModule } from 'primeng/inputotp';
import { TfaComponent } from "../tfa/tfa.component";
import { TfaType } from '@modules/settings/components/manage-users/interfaces/interfaces';
import { LoginLoadComponent } from "../login-load/login-load.component";

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [ChangePasswordFormComponent, StepperModule, InputOtpModule, TfaComponent, LoginLoadComponent],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {

  activeStep: number = 0;
  tfaData: TfaType | null = null;

  constructor(protected _auth: AuthService) { }

  isNewUser: boolean = this._auth.userDetail().project === null && !this._auth.userDetail().isPasswordUpdatedByUser && !this._auth.userDetail().isTfaConfigured;

  ngOnInit() {

    if(Object.keys(this._auth.tfaConfig()).length === 0) {
      this._auth.getUserDetails().subscribe({
        next: (res: any) => {
          this._auth.userDetail.set(res);
          if(this.isNewUser) {
            this.getTfaConfig();
          }
        },
        error: (err) => {
          console.error('Error fetching user details:', err);
        },
      })
    } else if(this.isNewUser) {
        this.getTfaConfig();
    }

    if(this._auth.userDetail().isPasswordUpdatedByUser) {
      this.activeStep = 1;
    }
  }

  getTfaConfig() {
    this._auth.getTFAData(this._auth.userDetail()._id).subscribe({
      next: (data) => {
        this.tfaData = data as TfaType;
      },
      error: (error) => {
        console.error('Error fetching TFA data:', error);
      }
    });
  }

  onPasswordSubmit() {
    this.activeStep = 1; // Move to the next step after password submission
  }
}
